export const publicPaymentGuardrailThresholdCents: string | undefined = process.env.NEXT_PUBLIC_PAYMENT_GUARDRAIL_THRESHOLD_CENTS;
export const publicSentryDsn: string | undefined = process.env.NEXT_PUBLIC_SENTRY_DSN;
